import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async'
import './index.css';
import './style.scss';
import { loadTranslations } from './assets/resources/translations'
import { getContent } from './assets/resources/content'
import { loadSettings } from './assets/resources/settings'
import Registration from './templates/Registration';
import RegistrationPreview from './views/RegistrationPreview';
import NotFound from './templates/NotFound';
import addTuiWrapper from './assets/resources/tuiWrapper';
import { getRoute } from './services/utils/pathOperations'

const start = async () => {
  const hostname = window.location.hostname;
  const match = /tui\.(se|dk|fi|no)/.exec(hostname);
  const brand = match?.[1] || "se";

  await loadSettings(hostname);
  await loadTranslations(brand);
  await addTuiWrapper();

  const pathname = window.location.pathname;
  let ComponentToRender = NotFound;
  let componentProps = {};

  const previewMatch = /^\/preview\/(.+)$/.exec(pathname);
  if (previewMatch) {
    const previewId = previewMatch[1];
    const content = await getContent(brand, previewId, "draft");
    if (content?.config) {
      ComponentToRender = RegistrationPreview;
      componentProps = { config: content.config, brand };
    }
  } else {
    const route = getRoute(pathname, hostname);
    const content = route ? await getContent(brand, route, "published") : undefined;
    if (content?.config) {
      ComponentToRender = Registration;
      componentProps = { config: content.config };
    }
  }

  ReactDOM.render(
    <HelmetProvider>
      <ComponentToRender {...componentProps} />
    </HelmetProvider>,
    document.getElementById("root")
  );
};


start();